//==============================================================
// ✅ Hook: useNotifications
//==============================================================
//
// Initializes notifications for the current user.
// Waits for settingsReady before starting WebSocket or polling.
// Re-initializes when user id or settingsReady / wsFlag change.
//

import { useEffect } from 'react';
import { notificationService } from '../utils/NotificationService';

export const useNotifications = (user, wsFlag = false, settingsReady = false) => {
    useEffect(() => {
        if (!user?.id) return;
        if (!settingsReady) return;

        const mode = wsFlag ? 'websocket' : 'polling';
        console.log('[useNotifications] init', { userId: user.id, mode });

        notificationService.init(user.id, wsFlag);

        return () => {
            console.log('[useNotifications] cleanup disconnect');
            notificationService.disconnect();
        };
    }, [user?.id, settingsReady, wsFlag]);

    const subscribe = (callback) => {
        if (!user?.id) return () => {};
        return notificationService.addListener(callback);
    };

    return { subscribe };
};
